
import { defineComponent, ref, onMounted } from 'vue'
import { AppMain, TopNav } from './components'

export default defineComponent({
  name: 'Layout',
  setup() {
    const classObj = {
      hideSidebar: true,
      openSidebar: false,
      withoutAnimation: true,
      mobile: false,
    }
    const siteTitle = '灵云AI轻应用'
    const siteLogo = require('@/assets/logo.png')
    const companyName = ref('北京捷通华声科技股份有限公司')
    // // 获取用户信息-公司名称
    // async function getUserInfo() {
    //   try {
    //     let res = await getUserInfoApi()
    //     companyName.value = res.data.username
    //   } catch (error) {
    //     error
    //   }
    // }
    return {
      classObj,
      siteTitle,
      siteLogo,
      companyName,
    }
  },
  components: {
    AppMain,
    TopNav,
  }
})
